class MemoryCache {
    cacheMap: Map<
        string,
        {
            value: any;
            expires?: number;
        }
    > = new Map();

    has(name: string) {
        return this.get(name) !== undefined;
    }

    /**
     * @param {string} name 缓存名
     * @param {any} value 缓存值
     * @param {number} expires 过期时间，单位为秒。不设置则永不过期
     */
    set(name: string, value: any, expires?: number) {
        this.cacheMap.set(name, {
            value,
            expires: expires && Date.now() + expires * 1000
        });

        return value;
    }

    get(name: string) {
        const cache = this.cacheMap.get(name);

        if (cache) {
            if (!cache.expires || Date.now() < cache.expires) {
                return cache.value;
            }

            this.cacheMap.delete(name);
        }
    }

    delete(name: string) {
        this.cacheMap.delete(name);
    }
}

export default MemoryCache;
